<nz-layout class="height-full">
    <nz-sider nzTheme="light" nzWidth="351px">
        <div class="am-dash-sider-container">
            <div class="am-dash-filter-panel am-dash-sider-content">
                <div>
                    <app-saved-dashboard-view></app-saved-dashboard-view>
                </div>
                <div *ngFor="let link of [modify_time_skadnetwork_datasource]">
                    <app-data-text
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-data-text>
                </div>
                <app-multi-select
                    [option]="settingSelectedMetrics.options"
                    [nzMaxTagCount]="0"
                ></app-multi-select>
                <div *ngFor="let link of values(filterDashboardItemLinks)">
                    <app-category-filter-dashboard-item
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'CategoryFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    >
                    </app-category-filter-dashboard-item>
                    <app-date-picker
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'DateRangeFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    >
                        ></app-date-picker
                    >
                    <app-segment-filter
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'SegmentsFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-segment-filter>
                </div>
            </div>
            <div class="am-dash-sider-footer">
                <div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            nzType="primary"
                            (click)="applyChangedFilters()"
                            [disabled]="isApplyButtonDisabled"
                            style="flex-grow: 1"
                        >
                            Apply
                        </button>
                    </div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            color="primary"
                            (click)="standardDashboardInitialize()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Restore defaults
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="reloadData()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Reload data
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </nz-sider>
    <nz-content class="am-dash-main-content">
        <div class="main-container">
            <app-table-dashboard-item
                [dashboardItem]="mastertable.dashboardItem"
                [dataLoaderEmitter]="mastertable.dataLoaderEmitter"
            ></app-table-dashboard-item>
        </div>
    </nz-content>
</nz-layout>
